import React from "react"
import styles from "./styles.scss"
import InfoItem from "components/InfoItem"

class JobInfo extends React.Component {
  render() {
    const {
      position,
      location,
      renderJobDescription,
      renderWeOffer,
      renderBenefits,
    } = this.props

    return (
      <section className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.info}>
            <InfoItem title="Position" icon={["fas", "briefcase"]}>
              {position}
            </InfoItem>
            <InfoItem title="Plats" icon={["fas", "map-marker-alt"]}>
              {location}
            </InfoItem>
            <InfoItem title="Kontaktperson" icon={["fas", "envelope"]}>
              Rasmus Sandström
              <br />
              <a
                href="mailto:rasmus@saits.se"
                className={styles.link}
                title="Mejla Rasmus Sandström"
              >
                rasmus@saits.se
              </a>
              <br />
              <a
                href="tel:+46722366791"
                className={styles.link}
                title="Ring Rasmus Sandström"
              >
                +46 72 236 67 91
              </a>
            </InfoItem>
          </div>
          <div className={styles.text}>
            <div className={styles.jobDescription}>
              {renderJobDescription()}
            </div>
            <div className={styles.weOffer}>{renderWeOffer()}</div>
            <div className={styles.benefits}>{renderBenefits()}</div>
          </div>
        </div>
      </section>
    )
  }
}

export default JobInfo



// WEBPACK FOOTER //
// ./src/components/JobDescription/JobInfo/index.jsx